import { Outlet } from "react-router-dom";

const RootShop = () => {
  return <Outlet />;
};

export default RootShop;
